import Vue from 'vue'
import VueRouter from 'vue-router'
import index from '../views/index/index.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: index,
    meta: {
      title: '评选活动'
    }
  },
  {
    path: '/vote',
    name: 'vote',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/detail/vote.vue'),
    meta: { title: '候选人' }
  },
  {
    path: '/winner',
    name: 'winner',
    component: () => import(/* webpackChunkName: "about" */ '../views/detail/winner.vue'),
    meta: { title: '获奖人' }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/spec/',
  routes
})

export default router
